import React from 'react';

import { Button } from '@mui/material';
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

import CommonStyles from './CommonStyles';

import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  intentMesBlock: {
    display: 'inline-flex',
    maxWidth: '800px',
    background: '#FFFF',
    alignItems: 'center',
    marginBottom: '10px',
    width: 'fit-content',
    padding: '10px 10px 10px 10px',
    boxShadow: '0px 1px 2px rgba(0, 0, 2, 0.1)',
    '&:hover': {
      boxShadow: '1px 3px 5px rgba(0, 0, 2, 0.1)',
    },
  },
  intentMesText: {
    color: '#4E4C4C',
  },
  intentMesBtn: {
    fontSize: 12,
    padding: '6px 20px',
    borderRadius: '20px',
    marginLeft: '10px',
    textTransform: 'none',
    '&:hover': {
      color: '#B74A00',
    },
  },
  ...CommonStyles,
});

const Intent = ({ intent, openTrplFormFull }) => {

  const classes = useStyles();

  const color = intent.complete ? '#2FB82C' : '#DD5900';

  return (
    <div
      className={classes.intentMesBlock}
      style={{ borderLeft: `3px solid ${color}` }}
    >
      <div style={{ display: 'inline-flex', alignItems: 'center', whiteSpace: 'break-spaces' }}>
        {intent.complete ? (
          <React.Fragment>
            <CheckCircleOutlineIcon
              style={{
                paddingRight: '10px',
                color: '#2FB82C',
                width: '18px'
              }}
            />
            <strong>{intent.title}</strong> completed!
          </React.Fragment>
          ) : (
            <React.Fragment>
              <ErrorOutlineIcon
                style={{
                  paddingRight: '10px',
                  color: '#DD5900',
                  width: '18px'
                }}
              />
                Please, complete <strong>{intent.title}</strong>
            </React.Fragment>
          )
        }
      </div>

      <Button
        onClick={() => {
          const formProps = {
            concept: intent.concept,
            node: intent.iid ? { id: intent.iid } : { id: intent.concept },
            groups: intent.groups,
            title: intent.title,
            formId: intent.id,
            mode: intent.iid ? 'edit' : 'create',
            tabs: intent.tabsTitles || []
          };
          if (intent.filter) formProps.graph_filter_id = intent.filter;
          openTrplFormFull(formProps);
        }
      }
        className={classes.intentMesBtn}
        style={{ color: `${color}` }}
      >
        {intent.complete ? 'Open' : 'Continue'}
        <ArrowForwardIosRoundedIcon
          style={{
            fontSize: 16,
            color: `${color}`,
            marginLeft: '3px',
          }}
        />
      </Button>
    </div>

  )

}

export default Intent;